import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { AiOutlineEye } from "react-icons/ai";
import { useNavigate } from "react-router";
import { IoMdArrowRoundBack } from "react-icons/io";
import { FaMarker } from "react-icons/fa";
import { message, Tooltip, Pagination } from "antd";
import { archiveProject } from "../../webServices/Apis";
import Loader from "../Loader/Loader";
import ViewProject from "./ProjectCrud/ViewProject";
import { BsFillBagCheckFill } from "react-icons/bs";
 

function ArchivedProjects() {
  const location = useLocation();
  const navigation = useNavigate();
  const { allProjects } = location.state || [];
  const [loading, setLoading] = useState(false);
  const [projectData, setProjectData] = useState({});
  const [viewProject, setViewProject] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const archivedProjects = allProjects?.filter(
    (data) => data?.isArchived === true
  );
  const reverseProjects = [...archivedProjects].reverse();

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentProjects = reverseProjects.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const handleBack = () => {
    navigation("/projects");
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleViewProject = (item) => {
    setViewProject(true);
    setProjectData(item);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  }

  const handleActiveProject = (item) => {
    setShowActivateModal(true);
    setProjectData(item)
  };


  const activateProject = async (status) => {
    try {
      setLoading(true);

      const response = await archiveProject(status, projectData?.id);
        if(response?.data?.success){
            message.success(response?.data?.message)
            navigation("/projects")
        }
    } catch (error) {
      console.log("Error in activating projects", error);
      message.error(error?.response?.data?.message);
    } finally {
        setLoading(false)
    }
  };

  return (
    <>
    {loading && <Loader/>}
      <div className="p-4">
        <div className="flex flex-row justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Archived Projects</h2>
          <Tooltip title="Back to active invoices">
            <button
              className="bg-blue-200 hover:bg-blue-400 font-bold w-10 h-10 rounded-full flex items-center justify-center border border-gray-900 shadow-md"
              onClick={handleBack}
            >
              <IoMdArrowRoundBack className="text-md" />
            </button>
          </Tooltip>
        </div>

        <table className="min-w-full bg-white border border-gray-800 border-b-4 mt-7">
          <thead className="bg-gray-800 text-white">
            <tr>
              <th className="py-3 px-4 text-center text-sm">Project Number</th>
              <th className="py-2 px-4 border-b text-center">Name</th>
              <th className="py-2 px-4 border-b text-center">Budget</th>
              <th className="py-2 px-4 border-b text-center">Address</th>
              <th className="py-2 px-4 border-b text-center">Start Date</th>
              <th className="py-2 px-4 border-b text-center">End Date</th>
              <th className="py-2 px-4 border-b text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {currentProjects.length > 0 ? (
              currentProjects.map((item, index) => (
                <tr
                  key={item.id}
                  className={`text-center transition ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-300"
                  }`}
                >
                  <td className="py-2 px-4 border-b">
                    {item.projectNumber || "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b">{item.projectName}</td>
                  <td className="py-2 px-4 border-b">{item.budget}</td>
                  <td className="py-2 px-4 border-b">
                    {item?.projectAddress?.length > 30
                      ? `${item?.projectAddress?.substring(0, 30)}...`
                      : item?.projectAddress}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {item.projectStartDate
                      ? formatDate(item.projectStartDate)
                      : "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b">
                    {item.dueDate ? formatDate(item.dueDate) : "N/A"}
                  </td>
                  <td className="py-2 px-4 border-b justify-center w-1/6">
                    <button
                      onClick={() => handleViewProject(item)}
                      className="mr-2 text-blue-500 hover:text-blue-700"
                    >
                      <AiOutlineEye className="text-2xl" />
                    </button>
                    <Tooltip title="Mark project as active">
                      <button
                        onClick={() => handleActiveProject(item)}
                        className="mr-2 text-green-500 hover:text-green-700"
                      >
                        <BsFillBagCheckFill className="text-2xl" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="py-2 px-4 border-b text-center">
                  No archived projects available
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {viewProject && (
            <ViewProject
            showViewProject={viewProject}
            setShowViewProject={setViewProject}
            selectedProject={projectData}
            />
        )}

        {showActivateModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
              <h3 className="text-3xl font-bold mb-4 text-start text-black">
                Confirm Activate
              </h3>
              <p className="mb-4 text-start text-black">
                Are you sure you want to active this project ?{" "}
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => {
                    setShowActivateModal(false);
                  }}
                  className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200"
                >
                  Cancel
                </button>
                <button
                  onClick={() => activateProject(false)}
                  className="bg-green-400 text-white py-3 px-8 rounded-md mr-2 hover:bg-green-700 transition duration-200"
                >
                  Active
                </button>
              </div>
            </div>
          </div>
        )}

         <div className="flex justify-end mt-4">
                  <Pagination
                    current={currentPage}
                    onChange={handlePageChange}
                    pageSize={itemsPerPage}
                    total={archivedProjects.length}
                  />
                </div>

      </div>
    </>
  );
}

export default ArchivedProjects;
